import { useCurrentUser } from '@common/current-user-layer/composables/useCurrentUser'

import type { IConversation, IConversationRecipient } from '../types/conversation.types'

/**
 * Chat identity and other-party resolution.
 * - Current user: platform id from auth (via useCurrentUser)
 * - Other party: normalized recipient on the conversation (recipientId from transform)
 * - Messages: sent vs received bubble alignment
 */
export function useChatParticipant() {
  const { getCurrentUserId } = useCurrentUser()

  /** Other party on a conversation (DM: first recepient with recipientId). */
  const getConversationRecipient = (conversation: IConversation | null | undefined): IConversationRecipient | null => {
    const recepients = conversation?.recepients ?? []
    return recepients.find(r => r.recipientId?.trim()) ?? recepients[0] ?? null
  }

  const isMessageFromCurrentUser = (message: { sender?: string }): boolean => {
    const sender = message.sender?.trim()
    const selfId = getCurrentUserId().trim()

    if (!sender || !selfId) {
      return false
    }

    return sender === selfId
  }

  return {
    getCurrentUserId,
    getConversationRecipient,
    isMessageFromCurrentUser,
  }
}
